export default __webpack_public_path__ + "static/media/04e_fold-23.d79aa0b8.mp4";